module.exports = __webpack_public_path__ + "static/img/icon-batchdeletion.47449a94.svg";